exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.cellNumberType[data-v-6f80548e] {\r\n  text-align: right;\n}\r\n", ""]);

// exports
